export enum EApiCallStateNames {
  DEMO = 'DEMO',
}

export enum EApiRequestPartKeys {
  SEARCH = 'SEARCH',
}
